import React from 'react'
import { useSelector } from 'react-redux'
import { CircularProgress } from '@material-ui/core'

import { ChampionshipCard } from '../ChampionshipCard'
import { SectionBlock } from '../SectionBlock'

const ChampionshipsSection = () => {
  const { championships, championshipsPending } = useSelector((state) => state.organizations)

  return (
    !!championships.length && (
      <SectionBlock title='Campeonatos del organizador'>
        {championshipsPending ? (
          <CircularProgress color='primary' size={32} />
        ) : (
          championships.map((c) => <ChampionshipCard key={c.id} championship={c} />)
        )}
      </SectionBlock>
    )
  )
}

export default ChampionshipsSection
